import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteCategorieComponent } from '../delete-categorie/delete-categorie.component';
import { ProduitService } from '../services/produit.service';
import { SnackBarService } from '../services/snack-bar.service';
import { ZoneService } from '../services/zone.service';

@Component({
  selector: 'app-delete-chauffeur',
  templateUrl: './delete-chauffeur.component.html',
  styleUrls: ['./delete-chauffeur.component.scss']
})
export class DeleteChauffeurComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteCategorieComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private produitService: ProduitService,private zoneService:ZoneService, private _snackBar: SnackBarService) { }

  ngOnInit(): void {
  }
  onClickYes(){
    this.zoneService.deleteChauffeur(this.data.id).subscribe(res => {
      this.dialogRef.close();
      this._snackBar.openSnackBar("Supression Reuissie!!", "Fermer");
    });
  }

  onClickNo(){
    this.dialogRef.close();
  }

}
